<div class="container-fluid" style="height: 100vh">
  <div class="main">
    <nav class="navbar navbar-light bg-white sticky-top pb-0 mx-3">
      <div class="container-fluid app-title">
        <a class="navbar-brand ms-2" routerLink="" title="Valfresco trgovina">
          <img src="assets/logo_header.png" width="100px" />
        </a>
        <div *ngIf="user" class="d-flex me-auto ms-5 my-1">
          <h5 class="text-primary mt-2 mx-3"><a [routerLink]="'user/company'">{{st.company?.Name}}</a></h5>
        </div>
        <div *ngIf="user" class="d-flex ms-5 ms-auto my-1">
          <h5 *ngIf="st.editedOrder" class="text-danger mt-2 mx-3" i18n>Order{{' ' + st.editedOrder.CartId + ' '}}</h5>
          <span class="mt-2">{{st.cart | valCartTotal:(st.refreshPrice | async) | number:'1.2-2'}} hrk</span>
          <button class="btn btn-link" [routerLink]="st.editedOrder?'order': 'cart'">
            <i *ngIf="!st.editedOrder" class="fas fa-shopping-cart"></i>
            <i *ngIf="st.editedOrder" class="fas fa-truck"></i>
            <span class="badge rounded-pill badge-top-right">{{st.cart.length}}</span>
          </button>
          <button #dropdownformtoggle class="btn btn-link">
            <i class="fas fa-user"></i>
            <ng-template [valDropDown]="dropdownformtoggle" [(valddVisible)]="dropDownVisible">
              <li class="nav-item"><a routerLink="login" (click)="logoff()" class="nav-link text-nowrap" aria-current="login" i18n>Log off</a></li>
              <hr class="dropdown-divider">
              <li class="nav-item">
                <a routerLink="user" (click)="dropDownVisible=false" class="nav-link text-nowrap" aria-current="user">
                  <span class="me-2" i18n>User</span>{{user?.DisplayName}}<span class="ms-2" i18n>info</span>
                </a>
              </li>
            </ng-template>
          </button>
        </div>
      </div>
    </nav>
    <div class="w-100">
      <div class="row">
        <div class="col">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <div class="w-100">
      <div class="row">
        <div class="col">
          <img src="assets/logo_footer.svg" class="img-fluid m-5" />
        </div>
      </div>
    </div>
  </div>
</div>
